<template>
    <div
        class="workstream-metrics-section"
        v-if="state.workstreamMetricsEnabled"
    >
        <div class="flex-row">
            <h2>
                {{ state.getWorkstreamMetrics?.headerName }}
            </h2>
            <InformationTooltip>
                <template #tooltip>
                    Lorem ipsum dolor sit amet, consectetur adipisci ng elit. Quisque nisl eros, rasdusto mollisg.
                </template>
                <template #icon>
                    <al-icon
                        icon="info-inverted"
                        variant="secondary"
                    />
                </template>
            </InformationTooltip>
        </div>
        <div>
            <SlidingToggle v-model="state.workstreamMetricsEnabled" />
        </div>
        <div>
            <CategorySection
                v-if="state.workstreamMetricsEnabled && state.getWorkstreamMetrics"
                :name="state.getWorkstreamMetrics.headerName"
                :children="state.getWorkstreamMetrics.children"
                :show-header="false"
            />
        </div>
    </div>
</template>
<script setup lang="ts">
import {
    CategorySection, InformationTooltip, SlidingToggle
} from '@/components';
import { state } from '@/utils/state';
</script>
<style lang="scss">
.metrics-configuration-container {
    .workstream-metrics-section {
        margin-bottom: 8px;
        margin-top: 32px;
    }
}
</style>
<style lang="scss">
@import './style.scss';
</style>
